import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// This is a counter that starts a counting animation when the counter enters the viewport.

// ! HTML CODE
// ! <span class="counter-count" data-count="120">0</span>

// ! DEPENDENCIES
/*  
<script defer src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.7.1/gsap.min.js"></script>
<script defer src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.7.1/ScrollTrigger.min.js"></script>
*/

function gsapCounter(elem, max, time = 0.75) {
	let min = { val: 0 };
	gsap.to(min, time, {
		val: max,
		// roundProps: "val",
		onUpdate: function () {
			// elem.innerHTML = () => (isInt(max) ? min.val : min.val.toFixed(2));
			isInt(max)
				? (elem.innerHTML = min.val.toFixed())
				: (elem.innerHTML = min.val.toFixed(2));
		},
	});
}

function isInt(n) {
	return n % 1 === 0;
}

gsap.registerPlugin(ScrollTrigger);
function triggerCounters() {
	document.querySelectorAll("[data-count]").forEach((elem) => {
		let max = elem.dataset.count;
		let isnum = /^\d+\.\d+$|^\d+$/.test(max);
		let animated = false;
		if (isnum) {
			ScrollTrigger.create({
				trigger: elem,
				start: "top 90%",
				onEnter: function () {
					if (!animated) gsapCounter(elem, max);
					animated = true;
				},
			});
		} else {
			elem.innerHTML = max;
		}
	});
}

function removeTriggers() {
	let triggers = ScrollTrigger.getAll();
	triggers.forEach((trigger) => {
		trigger.kill();
	});
}

export { gsapCounter, triggerCounters, removeTriggers };
